import React, {Component} from 'react';
import DeleteIcon from 'material-ui-icons/Cancel';
import AddIcon from 'material-ui-icons/PlaylistAdd';
import SelectIcon from 'material-ui-icons/FindInPage';
import DisableIcon from 'material-ui-icons/CheckCircle';
import EnableIcon from 'material-ui-icons/VisibilityOff';
import {
    Button,
    Grid,
    IconButton,
    Tooltip,
    TextField,
    MenuItem,
    Input,
    Typography
} from 'material-ui';
import SortableTree from 'react-sortable-tree';
import {
    addNewMenuItem,
    addRootMenuItem,
    disableMenuItem,
    enableMenuItem,
    updateMenuItemCSSClass,
    updateMenuItemExternalLink,
    updateMenuItemName,
    updateMenuItemType,
    moveMenuItem,
    validateMenuFields
} from './utils/menu_operations';
import {urlRegex} from '../../components/helpers/constants';
import ContentNodeRendererCustom from './theme/NodeRendererCustom';
import TreeNodeRendererCustom from './theme/TreeRendererCustom';
import {BackButton} from '../../components/buttons/BackButton';
import {SaveButton} from '../../components/buttons/SaveButton';

class MenuEditTree extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorUrl: false,
        }
    }

    render() {
        const {
            menuItemsTreeData,
            menuClasses,
            menuType,
            menuSite,
            classes,
            handleClickOpen,
            touched,
            loading,
            submitTreeData,
            updateMenuItemsTreeData,
            openRemoveDialog,
        } = this.props;

        return (
            <Grid container>
                <div className="heading">
                    <p className="lead">Edit <em>{menuType}</em> menu for <em>{menuSite}</em></p>
                </div>
                <Grid container direction="row" justify="flex-start">
                    <Grid item xs={12}className={classes.menuTree}>
                        <div style={{height: 700, width: 1280, display: 'contents' }}>
                            {<SortableTree
                                treeData={menuItemsTreeData}
                                onChange={treeData => updateMenuItemsTreeData(treeData)}
                                maxDepth={5}
                                theme={{
                                    nodeContentRenderer: ContentNodeRendererCustom,
                                    treeNodeRenderer: TreeNodeRendererCustom,
                                }}
                                onMoveNode={args => {
                                    const {treeData, node, path, nextParentNode} = args;
                                    moveMenuItem(treeData, node, path, nextParentNode, (treeData) => {
                                        updateMenuItemsTreeData(treeData)
                                    })
                                }}
                                generateNodeProps={({node, path}) => {

                                    if (node.deleted) {
                                        return null;
                                    }

                                    return ({
                                        title: (
                                            <div>
                                                <Input
                                                    className={classes.inputMenuTitle}
                                                    value={node.name}
                                                    onChange={event => {
                                                        let name = event.target.value;
                                                        updateMenuItemName(menuItemsTreeData, node, path, name, (treeData) => {
                                                            updateMenuItemsTreeData(treeData);
                                                        });
                                                    }}
                                                    placeholder="Add menu item name here...*"
                                                    error={node.name.length < 1}
                                                />
                                                {node.name.length < 1 && <span className={classes.menuNameError}>Please fill in the menu item name!</span>}
                                            </div>
                                        ),
                                        buttons: [
                                            <span>
                                                <TextField
                                                    select
                                                    name={node.title}
                                                    className={classes.selectMenuType}
                                                    value={node.type || 0}
                                                    onChange={event => {
                                                        let selectedType = event.target.value;
                                                        updateMenuItemType(menuItemsTreeData, node, path, selectedType, (treeData) => {
                                                            updateMenuItemsTreeData(treeData);
                                                        });
                                                    }}
                                                    error={node.type === 0}
                                                >
                                                    <MenuItem value={0} className={classes.selectMenuItem} disabled selected>Select menu type here*</MenuItem>
                                                    <MenuItem value="page" className={classes.selectMenuItem}>Page</MenuItem>
                                                    <MenuItem value="clickable_label" className={classes.selectMenuItem}>Clickable Label</MenuItem>
                                                    <MenuItem value="heading_label" className={classes.selectMenuItem}>Heading Label</MenuItem>
                                                    <MenuItem value="link" className={classes.selectMenuItem}>External Link</MenuItem>
                                                </TextField>
                                                {node.type === 0 && <span className={classes.menuTypeError}>Please select a menu type!</span>}
                                                {node.type === "page" && node.page_id === null && <span className={classes.menuTypeError}>Please click on the search icon to find and select a page from the existing pages!</span>}
                                            </span>,
                                            node.type === "page" ?
                                                <div>
                                                    <span>
                                                        <Tooltip title="Search &amp; Select Page*">
                                                            <IconButton
                                                                className="smallIconButtonMenuTree viewColor"
                                                                onClick={e => handleClickOpen(node, path)}
                                                            >
                                                                <SelectIcon/>*
                                                            </IconButton>
                                                        </Tooltip>
                                                    </span>
                                                    {node.page_title !== null && node.page_title.length > 0 && 
                                                        <span className={classes.selectedPageInfoText}>
                                                            Page info: <strong>Initial page name -> "{node.page_title}"{node.page_id !== null ? ', page ID -> ' + node.page_id : ''}</strong>
                                                        </span>
                                                    }
                                                </div>
                                                : '',
                                            node.type === "link" ?
                                                <span>
                                                    <TextField
                                                        id="external-menu-url"
                                                        autoFocus={true}
                                                        value={node.href || ''}
                                                        onChange={(event) => {
                                                            let externalLink = event.target.value;
                                                            updateMenuItemExternalLink(menuItemsTreeData, node, path, externalLink, (treeData) => {
                                                                updateMenuItemsTreeData(treeData);
                                                            });

                                                            if (externalLink.match(urlRegex)) {
                                                                this.setState({
                                                                    errorUrl: false
                                                                })
                                                            } else {
                                                                this.setState({
                                                                    errorUrl: true
                                                                })
                                                            }

                                                            if (externalLink === '') {
                                                                this.setState({
                                                                    errorUrl: true
                                                                })
                                                            }
                                                        }}
                                                        type="url"
                                                        className={classes.inputLink}
                                                        placeholder="Add external link here...*"
                                                        error={this.state.errorUrl}
                                                    />
                                                    {this.state.errorUrl && <span className={classes.externalMenuUrlError}>Please fill in a valid link like: www.google.com, https://google.com, http://google.com!</span>}
                                                </span>
                                                : '',
                                            <span>
                                                <Tooltip title="Add Menu Item Children">
                                                    <IconButton
                                                        className="smallIconButtonMenuTree editColor"
                                                        onClick={() => {
                                                            addNewMenuItem(menuItemsTreeData, node, path, (treeData) => {
                                                                updateMenuItemsTreeData(treeData)
                                                            });
                                                        }}>
                                                        <AddIcon/>
                                                    </IconButton>
                                                </Tooltip>
                                            </span>,
                                            node.is_visible ?
                                                <span>
                                                    <Tooltip title="Menu Item is visible on the website! Click here to DISABLE Menu Item">
                                                        <IconButton
                                                            className="smallIconButtonMenuTree enableColor"
                                                            onClick={() => {
                                                                disableMenuItem(menuItemsTreeData, node, path, (treeData) => {
                                                                    updateMenuItemsTreeData(treeData);
                                                                });
                                                            }}
                                                        >
                                                            <DisableIcon/>
                                                        </IconButton>
                                                    </Tooltip>
                                                </span>
                                                :
                                                <span>
                                                    <Tooltip title="Menu Item is not visible on the website! Click here to ENABLE Menu Item">
                                                        <IconButton
                                                            className="smallIconButtonMenuTree disableColor"
                                                            onClick={() => {
                                                                enableMenuItem(menuItemsTreeData, node, path, (treeData) => {
                                                                    updateMenuItemsTreeData(treeData);
                                                                });
                                                            }}
                                                        >
                                                            <EnableIcon/>
                                                        </IconButton>
                                                    </Tooltip>
                                                </span>,
                                            <span>
                                                <Tooltip title="Remove Menu Item">
                                                    <IconButton
                                                        className="smallIconButtonMenuTree deleteColor"
                                                        onClick={(e) => openRemoveDialog(node, path)}
                                                    >
                                                        <DeleteIcon/>
                                                    </IconButton>
                                                </Tooltip>
                                            </span>,
                                            <span>
                                                <TextField
                                                    select
                                                    className={classes.selectMenuClass}
                                                    name={node.name}
                                                    value={node.css_class === null ? 0 : node.css_class}
                                                    onChange={event => {
                                                        let cssClass = event.target.value;
                                                        updateMenuItemCSSClass(menuItemsTreeData, node, path, cssClass, (treeData) => {
                                                            updateMenuItemsTreeData(treeData);
                                                        });
                                                    }}
                                                >
                                                    <MenuItem value={0} className={classes.selectMenuItem} selected disabled> Select CSS class here</MenuItem>
                                                    <MenuItem value={null} className={classes.selectMenuItem}> No CSS class</MenuItem>
                                                    {menuClasses.map(option => (
                                                        <MenuItem
                                                            key={option.id}
                                                            value={option.class_name}
                                                            className={classes.selectMenuItem}
                                                        >
                                                            {option.display_name}
                                                        </MenuItem>
                                                    ))}
                                                </TextField>
                                            </span>,
                                            node.deleted === true ?
                                                <span>
                                                    <div className={classes.deletedMenuItem}><em>This item and its children have been deleted from the menu!<br/>After saving, the changes will be visible in the menu.</em></div>
                                                </span>
                                            : '',
                                        ],
                                    });
                                }}
                            />}
                            <Typography variant="caption" color="error" style={{margin: "10px 0 0 14px"}}>*Mandatory fields</Typography>
                        </div>
                    </Grid>
                    <Grid item xs={12} className={classes.menusButtons}>
                        <Button
                            variant="raised"
                            color="default"
                            className={classes.addMenuItemBtn}
                            onClick={() => {
                                addRootMenuItem(menuItemsTreeData, (treeData) => {
                                    updateMenuItemsTreeData(treeData);
                                });
                            }}
                        >
                            Add Menu Item
                        </Button>
                        <SaveButton
                            type="submit"
                            loading={loading}
                            disabled={validateMenuFields(touched, loading, this.state.errorUrl, this.props.menuItemsTreeData)}
                            variant="raised"
                            color="primary"
                            className="floatRight"
                            onClick={() => submitTreeData()}
                        />
                        <BackButton
                            link={"/menus"}
                            style={{marginRight: 15}}
                            variant="raised"
                            className="floatRight"
                            touched={touched}
                        />
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}

export default MenuEditTree;


// WEBPACK FOOTER //
// ./src/containers/menus/MenuEditTree.jsx